import React from 'react';
import { EXPERIENCE_FLOW } from '../data/content';
export function LearningExperience() {
  return <section aria-labelledby="experience-title" className="w-full bg-navy px-3 py-6 sm:px-5" data-id="element-152" data-mp="29gi7t9aby3wg">
      <div className="mx-auto max-w-5xl" data-id="element-153" data-mp="2ngaxr2e18g3d">
        <h2 id="experience-title" className="text-center font-head text-2xl uppercase leading-none text-white sm:text-4xl" data-id="element-154" data-mp="2nhcki44eur0x">
          One complete learning experience
        </h2>

        <ol className="mt-3 grid gap-1.5 sm:grid-cols-2 lg:grid-cols-5" data-id="element-155" data-mp="2wfejyf8hxbm3">
          {EXPERIENCE_FLOW.map(step => <li key={step.name} className="flex flex-col rounded-xl bg-white/5 p-2.5 text-center" data-id="element-156" data-mp="2se2zeo4hbgkr">
              <span className={`mx-auto block h-1.5 w-10 rounded-full ${step.accent}`} aria-hidden="true" data-id="element-157" data-mp="364y1nhkh2zfd" />
              <span className="mt-1.5 block font-head text-[13px] uppercase leading-tight text-white sm:text-sm" data-id="element-158" data-mp="317ptm9t1gbru">
                {step.name}
              </span>
              <span className="mt-auto block pt-1 text-[9px] font-bold uppercase tracking-widest text-orange sm:text-[10px]" data-id="element-159" data-mp="3b5vr8f7tavqw">
                {step.role}
              </span>
            </li>)}
        </ol>

        <p className="mt-3 text-center font-head text-base uppercase tracking-wide text-white sm:text-xl" data-id="element-160" data-mp="1x4ooaojjfkk3">
          Everything works together.
        </p>
      </div>
    </section>;
}